var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA4Powergrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.75 36.19l-.68-.37-13.59-7.24-.14-.58h13.72a1.46 1.46 0 001.42-1.12 1.49 1.49 0 00-.73-1.68l-.68-.36-16.65-8.9-1.6-6.56A2 2 0 0037.06 8a2 2 0 00-1.11 1.42l-1.65 6.81-17 9A1.49 1.49 0 0018 28h13.44l-.2.83-14 7.36A1.49 1.49 0 0018 39h10.68l-5.83 24H27l5.83-24H43l5.83 24h4.12L47.1 39h11a1.46 1.46 0 001.42-1.12 1.5 1.5 0 00-.77-1.69zM29.43 36h-5.55l6.36-3.36-.81 3.36zm8.46-17.81L39.54 25h-3.3l1.65-6.81zM32.12 25h-8.24l9.45-5-1.21 5zm1.43 11L35 30.16l3.18-1.67 2.61 1.39L42.24 36h-8.69zm8.84-16.24L52.2 25h-8.54l-1.27-5.24zm4 16.24l-.87-3.59L52.2 36h-5.81z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A4_Powergrid.a2631677.svg";
export { SvgA4Powergrid as ReactComponent };